export default __webpack_public_path__ + "static/media/signup_4.15e5da96.jpg";